import { render, staticRenderFns } from "./QR.vue?vue&type=template&id=7daaa35d&scoped=true&"
import script from "./QR.vue?vue&type=script&lang=js&"
export * from "./QR.vue?vue&type=script&lang=js&"
import style0 from "./QR.vue?vue&type=style&index=0&id=7daaa35d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7daaa35d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
